import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import './ListaPrecios.css'
import { Button, FormControl, InputLabel, Select, MenuItem, TextField, IconButton, Icon, InputAdornment, Checkbox, FormControlLabel, Snackbar, Slide, CircularProgress } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from "@material-ui/pickers";
import Filtrolp from '../../components/listaprecios/Filtrolp';
import DateFnsUtils from '@date-io/date-fns';
import Http from '../../Http';
import { getBase64 } from "../../helpers";

export const Especificacion = (props) => {
  const opsValor = [
    { value: 1, label: 'Precio' },
    { value: 2, label: 'Descuento' },
    { value: 3, label: 'Por Porcentaje' },
  ]
  props.ops.tipos_listas = props.ops.tipos_listas ? props.ops.tipos_listas.filter(tp => !tp.lpt_independiente) : [];

  return (
    <div style={{ padding: 5 }} className='espec in'>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div className='form'>
          <FormControl variant='outlined'>
            <InputLabel>Tipo</InputLabel>
            <Select
              value={props.tipo}
              onChange={(e) => { props.onChange('id_lista_precio_tipo', e.target.value) }}
            >
              {props.ops.tipos_listas.map((op, oi) => (
                <MenuItem value={op.id} key={oi}>{op.lpt_nombre}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        {props.tipo !== 10 && (
          <div className='form'>
            <FormControl variant='outlined'>
              <InputLabel>Tipo de valor</InputLabel>
              <Select
                value={props.tipoValor}
                onChange={(e) => { props.onChange('id_valor_aplicado', e.target.value) }}
              >
                {opsValor.map((op, oiv) => (
                  <MenuItem value={op.value} key={oiv}>{op.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        )}
        <div className='form'>
          <FormControl style={{ minWidth: 50, maxWidth: 200 }}>
            <TextField
              InputProps={{
                startAdornment: props.tipoValor === 1 && props.tipo !== 10 ? <InputAdornment position='start'>$</InputAdornment> : null,
                endAdornment: props.tipoValor === 2 && props.tipo !== 10 ? <InputAdornment position='end'>%</InputAdornment> : null,
              }}
              variant='outlined' label='Valor' value={props.valor} onChange={(e) => { props.onChange('valor_aplicado', e.target.value) }} />
          </FormControl>
        </div>
        {props.tipo === 10 && (
          <React.Fragment>
            <div className="form">
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <FormControl className='form-field'>
                  <KeyboardDateTimePicker
                    inputVariant="outlined"
                    variant="inline"
                    ampm={false}
                    value={props.fecha_inicio}
                    label={'Fecha Inicio'}
                    format="dd/MM/yyyy HH:mm"
                    style={{ width: 212 }}
                    onChange={(e) => { props.onChange('lpe_fecha_inicio', e) }} />
                </FormControl>
              </MuiPickersUtilsProvider>
            </div>
            <div className="form">
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <FormControl className='form-field'>
                  <KeyboardDateTimePicker
                    style={{ width: 212 }}
                    inputVariant="outlined"
                    variant="inline"
                    ampm={false}
                    value={props.fecha_fin}
                    label={'Fecha Fin'}
                    format="dd/MM/yyyy HH:mm"
                    onChange={(e) => { props.onChange('lpe_fecha_termino', e) }} />
                </FormControl>
              </MuiPickersUtilsProvider>
            </div>
          </React.Fragment>
        )}
        <div>
          {
            props.onRemove && (
              <IconButton onClick={() => { props.onRemove() }}>
                <Icon>remove_circle</Icon>
              </IconButton>
            )
          }
          <IconButton onClick={() => { props.addCond() }}>
            <Icon>add_circle</Icon>
          </IconButton>
        </div>
      </div>
      <div className='conds'>
        {props.children}
      </div>
    </div>
  )
}

export const Condicion = (props) => {
  // const opsTipo = [
  //   { value: 1, label: 'KG' },
  //   { value: 2, label: 'KM' },
  //   { value: 3, label: 'Origen/destino' },
  //   { value: 4, label: 'Unidades' },
  // ]

  return (
    <div style={{ display: 'block' }} className='cond in'>
      <div className='rama'></div>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div className='form'>
          <FormControl variant='outlined' style={{ minWidth: 100 }}>
            <InputLabel>Tipo</InputLabel>
            <Select
              value={props.tipo}
              onChange={(e) => { props.onChange('id_tipo_condicion', e.target.value) }}
            >
              {props.ops.tipos_condicion.map((op, oi) => (
                <MenuItem value={op.id} key={oi}>{op.tc_nombre}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        {props.tipo === 2 && (
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div className='form'>
              <FormControl variant='outlined' style={{ minWidth: 100 }}>
                <InputLabel>Origen</InputLabel>
                <Select
                  value={props.valor1}
                  onChange={(e) => { props.onChange('valor_1', e.target.value) }}
                >
                  {props.ops.origenes.map((op, oiv) => (
                    <MenuItem value={op.id} key={oiv}>{op.sucursal}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div className='form'>
              <FormControl variant='outlined' style={{ minWidth: 100 }}>
                <InputLabel>Destino</InputLabel>
                <Select
                  value={props.valor2}
                  onChange={(e) => { props.onChange('valor_2', e.target.value) }}
                >
                  {props.ops.destinos.map((op, oiv) => (
                    <MenuItem value={op.id} key={oiv}>{op.sucursal}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>)
        }
        {props.tipo === 4 && (
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div className='form'>
              <FormControl variant='outlined' style={{ minWidth: 100 }}>
                <InputLabel>Origen</InputLabel>
                <Select
                  value={props.valor1}
                  onChange={(e) => { props.onChange('valor_1', e.target.value) }}
                >
                  {props.ops.zonas.map((op, oiv) => (
                    <MenuItem value={op.id} key={oiv}>{op.zona}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>)
        }
        {props.tipo === 8 && (
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div className='form'>
              <FormControl variant='outlined' style={{ minWidth: 100 }}>
                <InputLabel>Nombre Ruta</InputLabel>
                <Select
                  value={props.valor1}
                  onChange={(e) => { props.onChange('valor_1', e.target.value) }}
                >
                  {props.ops.rutas.map((op, oiv) => (
                    <MenuItem value={op.id} key={oiv}>{op.ruta}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>)
        }
        {props.tipo !== 2 && props.tipo !== 4 && props.tipo !== 8 && (
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            {
              (props.tipo === 1 || props.tipo === 7) && (
                <div className='form'>
                  <FormControl variant='outlined' style={{ minWidth: 100 }}>
                    <InputLabel>Embalaje</InputLabel>
                    <Select
                      value={props.id_embalaje}
                      onChange={(e) => { props.onChange('id_embalaje', e.target.value) }}
                    >
                      {props.ops.embalajes.map((op, oiv) => (
                        <MenuItem value={op.id} key={oiv}>{op.embalaje_nombre}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              )
            }
            {
              (props.tipo !== 6 && props.tipo !== 7) && (
                <React.Fragment>
                  <div className='form'>
                    <FormControl style={{ minWidth: 50 }}>
                      <TextField type='number' variant='outlined' label='Mínimo' value={props.valor1} onChange={(e) => { props.onChange('valor_1', e.target.value) }} />
                    </FormControl>
                  </div>
                  <div className='form'>
                    <FormControl style={{ minWidth: 50 }}>
                      <TextField type='number' variant='outlined' label='Máximo' value={props.valor2} onChange={(e) => { props.onChange('valor_2', e.target.value) }} />
                    </FormControl>
                  </div>
                </React.Fragment>
              )
            }
          </div>
        )}
        <div>
          <IconButton onClick={() => { props.onRemove() }}>
            <Icon>remove_circle</Icon>
          </IconButton>
        </div>
      </div>
    </div>
  )
}

class ListaPrecios extends Component {

  static defaultProps = {
    id: null
  }

  constructor(props) {
    super(props);
    this.excelInput = React.createRef()
    this.scrollT = true;
    this.scrollCount = 0;

    this.state = {
      // especificaciones: []
      loadingExcel: false,
      lpNombre: '',
      lpDefault: false,
      saveLoading: false,
      sbOpen: false,
      sbMsg: '',
      id_lp_opcion: '1',
      ops: {
        tipos: [{ value: 1, label: 'Recolección' }, { value: 2, label: 'Flete' }, { value: 3, label: 'Entrega' }],
        origenes: [],
        destinos: [],
        embalajes: [],
        tipos_condicion: [],
        tipos_listas: [],
        rutas: [],
        lp_opciones: [],
      },
      especificaciones: [
        // {
        //   tipo: 1, tipoValor: 1, valor: 0,
        //   condiciones: [
        //     { tipo: 1, valor1: 0, valor2: 0 },
        //     { tipo: 1, valor1: 0, valor2: 0 },
        //   ]
        // }
      ],
      especificacionesRemovidas: [],
      scrollLoad: false,
      scrollLoadEnd: false,
      query: '',
    }
  }

  async componentDidMount() {
    await this.loadFormData();
    if (!this.props.nuevaData) {
      await this.loadData();
    }
    this.scrollEnd();
  }

  componentWillUnmount() {
    if (this.props.scrollInnerContent) {
      document.getElementById('scrollContent').removeEventListener('scroll', this.scrollEvent);
    } else {
      document.removeEventListener('scroll', this.scrollEvent);
    }
  }

  loadData = async (query, restart) => {
    const lpId = this.props.id ? this.props.id : this.props.match.params.id;
    this.setState({ loadingExcel: !!lpId, scrollLoad: !!lpId });

    const Res = await Http.get(`lista-precio/one/${lpId}?sc=${this.scrollCount}&query=${query}`);
    if (!Res.error) {
      let especs = Res.data.especificaciones;
      if (especs.length === 0) this.setState({ scrollLoadEnd: true })
      let stEspecs = this.state.especificaciones;
      if ((query && this.scrollCount === 0) || restart) {
        stEspecs = especs;
      } else {
        stEspecs.push(...especs);
      }
      this.setState({
        especificaciones: stEspecs,
        lpNombre: Res.data.lp_nombre,
        lpId: Res.data.id,
        lpDefault: Res.data.lp_default,
        scrollLoad: false,
        loadingExcel: false,
        id_lp_opcion: Res.data.id_lp_opcion,
      })
    } else {
      this.setState({ scrollLoad: false, loadingExcel: false })
    }
  }

  loadFormData = async (form) => {
    var Res = await Http.get('lista-precio/lp');
    if (!Res.error) {
      this.setState({ ops: { ...this.state.ops, ...Res.data } })
    }

  }

  addEspec = () => {
    let especs = this.state.especificaciones;
    especs.push({
      id_lista_precio: this.props.id ? this.props.id : this.props.match.params.id,
      id_lista_precio_tipo: 1,
      id_valor_aplicado: 1,
      valor_aplicado: 0,
      condiciones: []
    })
    this.setState({ especificaciones: especs });
  }

  especChange = (f, t, v) => {
    let especs = this.state.especificaciones;
    if (t === 'id_lista_precio_tipo' && v === 10) {
      especs[f]['id_valor_aplicado'] = 1;
    }
    if (t === 'id_valor_aplicado' && v === 3) {
      especs[f]['id_lista_precio_tipo'] = 2;
    }
    especs[f][t] = v;
    this.setState({ especificaciones: especs });
  }

  especAddCond = (f) => {
    let especs = this.state.especificaciones;
    especs[f].condiciones.push({ id_tipo_condicion: 1, valor_1: 0, valor_2: 0, id_embalaje: 0 })
    this.setState({ especificaciones: especs });
  }

  especRemove = (f) => {
    const especificacionesRemovidas = this.state.especificaciones.filter((espec, i) => (f === i && espec.id));
    let especs = this.state.especificaciones.filter((espec, i) => f !== i);
    this.setState({ especificaciones: especs, especificacionesRemovidas: [...especificacionesRemovidas, ...this.state.especificacionesRemovidas] });
  }

  condChange = (f, fc, t, v) => {
    let especs = this.state.especificaciones;
    especs[f].condiciones[fc][t] = v;
    if (especs[f].condiciones[fc].id_tipo_condicion === 2 && (t === 'valor_1' || t === 'valor_2') & v === -1) {
      especs[f].condiciones[fc]['valor_1'] = -1;
      especs[f].condiciones[fc]['valor_2'] = -1;
    }
    this.setState({ especificaciones: especs });
  }

  condRemove = async (fe, fc) => {
    let especs = this.state.especificaciones;
    if (especs[fe].condiciones[fc].id) {
      let Res = await Http.post('lista-precio/condicion/delete', { id: especs[fe].condiciones[fc].id });
      if (!Res.error) {
        this.loadData();
      }
    }
    especs[fe].condiciones = especs[fe].condiciones.filter((espec, i) => fc !== i);
    this.setState({ especificaciones: especs });
  }

  saveLista = async () => {
    const { especificaciones, lpId, lpNombre, lpDefault, especificacionesRemovidas, id_lp_opcion } = this.state;
    this.setState({ saveLoading: true })
    // let saveObj = { especificaciones, id: lpId, lp_nombre: lpNombre }
    try {
      const listaPrecios = { especificaciones, id: lpId, lp_nombre: lpNombre, lp_default: lpDefault, id_lp_opcion };
      // return console.log({ listaPrecios });
      let Res = await Http.post(`lista-precio/save`, { listaPrecios, especificacionesRemovidas });
      if (!Res.error) {
        if (Res.data.error) {
          this.setState({ sbMsg: Res.data.errMsg, sbOpen: true, saveLoading: false })
        } else {
          // let especs = Object.assign(this.state.especificaciones, Res.data.especs);
          this.setState({ ...this.reset(), sbMsg: 'Guardado', sbOpen: true });
          if (this.props.onSave) {
            this.props.onSave(Res.data)
          } else {
            this.props.history.push(`/ListasDePrecios`)
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  reset() {
    return {
      lpNombre: '',
      lpDefault: false,
      saveLoading: false,
      sbOpen: false,
      sbMsg: '',
      id_lp_opcion: '1',
      ops: {
        tipos: [{ value: 1, label: 'Recolección' }, { value: 2, label: 'Flete' }, { value: 3, label: 'Entrega' }],
        origenes: [],
        destinos: [],
        embalajes: [],
        tipos_condicion: [],
        tipos_listas: [],
        lp_opciones: []
      },
      especificaciones: []
    }
  }

  onExcelChange = async (event) => {
    console.log(event.target.files);
    if (event.target.files && event.target.files[0]) {
      const file = await getBase64(event.target.files[0]);
      this.setState({ loadingExcel: true })
      try {
        const Res = await Http.post('lista-precio/upload-excel', {
          id_lista_precio: this.props.id ? this.props.id : this.props.match.params.id,
          file,
        });
        if (!Res.error) {
          const { especificaciones } = Res.data;
          this.setState({ especificaciones, loadingExcel: false });
        } else {
          this.setState({ loadingExcel: false });
        }
      } catch (error) {
        this.setState({ loadingExcel: false });
      }
    }
  }

  scrollEnd = () => {
    if (this.props.scrollInnerContent) {
      document.getElementById('scrollContent').addEventListener('scroll', this.scrollEvent);
    } else {
      document.addEventListener('scroll', this.scrollEvent);
    }
  }

  onScrollEnd = () => {
    this.scrollCount++;
    this.setState({ scrollLoad: true })
    this.loadData(this.state.querylp);
  }

  scrollEvent = () => {
    const wrappedElement = document.getElementById('lpscroll');
    if (wrappedElement && wrappedElement.getBoundingClientRect().bottom <= window.innerHeight) {
      // if (this.isBottom(wrappedElement)) {
      // console.log('header bottom reached');
      // document.removeEventListener('scroll', this.trackScrolling);
      // if (this.scrollT) {
      if (!this.state.scrollLoad && !this.state.scrollLoadEnd && this.scrollT) {
        this.onScrollEnd();
        this.scrollT = false;
        setTimeout(() => {
          this.scrollT = true;
        }, 1000);
      }
    }
  }

  onFilter = (query) => {
    let querylp = JSON.stringify(query)
    this.setState({ querylp });
    this.loadData(querylp, true);
  }

  render() {
    const { especificaciones, ops, lpNombre, saveLoading, lpDefault, sbMsg, sbOpen, scrollLoad, scrollLoadEnd, loadingExcel, id_lp_opcion } = this.state;
    return (
      <div style={{ padding: 5, backgroundColor: 'white', margin: '0 10px', overflowY: 'auto' }} id="scrollContent">
        <h1>Lista de precios {lpNombre && lpNombre.length > 0 ? `'${lpNombre}'` : ''}</h1>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
          <div className='form' >

            {/* <FormControl style={{ minWidth: 240 }}> */}
            <div className='row'>
            <div className='col-sm-12'>
              <TextField
                className="form-field"
                label="Nombre de la Lista de Precios"
                variant='outlined'
                value={lpNombre}
                style={{ minWidth: 240 }}
                onChange={(e) => { this.setState({ lpNombre: e.target.value }) }}
              />
            </div>
            <div className='col-sm-6'>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={lpDefault === 1 || lpDefault === true}
                    onChange={(e) => { this.setState({ lpDefault: e.target.checked }) }}
                    value="primary"
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                  />
                }
                label="Lista de Precios Default"
              />
            </div>
            <div className='col-sm-6'>
              <FormControl variant="outlined" className='form-field'>
                <InputLabel>Tipo</InputLabel>
                <Select
                  value={id_lp_opcion+''}
                  onChange={(e) => { this.setState({ id_lp_opcion : e.target.value }) }}
                >
                  {ops.lp_opciones.map((option, i) => {
                    return (<MenuItem value={option.id} key={option.id}>{option.nombre}</MenuItem>)
                  })}
                </Select>
              </FormControl>
            </div>
            </div>

            {/* </FormControl> */}
          </div>
          {especificaciones && especificaciones.length > 0 && <Filtrolp ops={ops} onFilter={this.onFilter} />}
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', margin: '10px 0' }} >
            <input type='file' onChange={this.onExcelChange} ref={this.excelInput} style={{ display: 'none' }} />
            <Button disabled={saveLoading} onClick={this.addEspec} style={{ marginRight: 10 }}>Agregar especificación</Button>
            <Button onClick={() => { this.excelInput.current.click() }} variant='contained' color='primary'>Subir Excel</Button>
            <Button disabled={saveLoading || lpNombre === ''} onClick={this.saveLista} variant='contained' color='primary'>Guardar</Button>
          </div>
        </div>

        <div id="lpscroll">
          {/* el query tarda demasiado, ademas hay que ver una manera mas optima
           <ListaPreciosMin /> */}
          {especificaciones && especificaciones.length > 0 && especificaciones.map((espec, i) => (
            <Especificacion
              key={i}
              tipo={espec.id_lista_precio_tipo}
              tipoValor={espec.id_valor_aplicado}
              valor={espec.valor_aplicado}
              ops={ops}
              onChange={(t, v) => { this.especChange(i, t, v) }}
              addCond={() => { this.especAddCond(i) }}
              onRemove={() => { this.especRemove(i) }} >
              {espec.condiciones && espec.condiciones.map((cond, ic) => (
                <Condicion
                  key={ic}
                  onChange={(t, v) => { this.condChange(i, ic, t, v) }}
                  onRemove={() => this.condRemove(i, ic)}
                  tipo={cond.id_tipo_condicion}
                  ops={ops}
                  valor1={cond.valor_1}
                  valor2={cond.valor_2}
                  id_embalaje={cond.id_embalaje}
                />
              ))}
            </Especificacion>
          ))}
          {/* {
            scrollLoad && (
              <div style={{ textAlign: 'center' }}>Cargando...</div>
            )
          } */}
          {
            scrollLoadEnd && (
              <div style={{ textAlign: 'center' }}>No hay más especificaciones</div>
            )
          }
          {
            (loadingExcel || scrollLoad) && (
              <div style={{ display: 'flex', flexFlow: 'column nowrap', justifyContent: 'center', alignItems: 'center' }} >
                <CircularProgress />
                Cargando...
              </div>)
          }
        </div>

        <div>
          <Snackbar
            open={sbOpen}
            onClose={() => { this.setState({ sbOpen: false }) }}
            TransitionComponent={Slide}
            message={<span id="">{sbMsg}</span>}
          />
        </div>
      </div>
    )
  }
}

export default withRouter(ListaPrecios)